import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NotificationService,
  NotificationType,
} from '../services/notification.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  notificationService = inject(NotificationService);

  typeClasses(type: NotificationType): string {
    switch (type) {
      case 'login':
      case 'info':
        return 'border-blue-500';
      case 'verify':
        return 'border-orange-500';
      case 'pro':
      case 'success':
        return 'border-green-500';
      case 'error':
        return 'border-red-500';
    }
  }
}
